import React from 'react';
import DefaultPage from './DefaultPage';
import BtypePage from './BtypePage';
import CtypePage from './CtypePage';

// 회사(companyEntity.regNo) -> sys_code(DASHBOARD_TYPE) 조회로 내려오는 dashboardType 값과
// 렌더링할 대시보드 컴포넌트를 매핑한다.
// 새로운 대시보드 타입을 추가하려면:
//   1) sys_code 에 major_cd='DASHBOARD_TYPE', minor_cd=<회사 regNo>, code_nm=<새 타입 코드> 등록
//   2) 아래 맵에 <새 타입 코드>: <해당 대시보드 컴포넌트> 한 줄 추가
// 이 매핑에 없는 dashboardType 값은 DefaultPage 로 자동 폴백된다.
export const DASHBOARD_COMPONENTS: Record<string, React.FC> = {
    A: DefaultPage,
    B: BtypePage,
    C: CtypePage,
};

export const getDashboardComponent = (dashboardType?: string | null): React.FC => {
  const normalizedType = (dashboardType || '').trim();
  return DASHBOARD_COMPONENTS[normalizedType] ?? DefaultPage;
};
